module.exports = __webpack_public_path__ + "static/media/download-bg.0e66d4f0.png";